import React from "react"
import get from "lodash/get"
import "./styles.less"
import cx from "classnames"
import nl2br from "../../utils/nl2br"

const OverviewItem = ({ noImage, data }) => {
  const { sectionTitle, description, image, imageLeft = false } = data
  return (
    <div className="overview-item">
      <div className="container">
        <div className="row align-items-center">
          <div
            className={cx(
              { "col-md-5 offset-md-1 order-last": !noImage && imageLeft },
              { "col-md-6 col-lg-5": !noImage && !imageLeft },
              { "col-md-9 col-lg-9": noImage }
            )}
          >
            <h2>{sectionTitle}</h2>
            {description && <p>{nl2br(description)}</p>}
          </div>
          {!noImage && get(image, "[0].url", false) && (
            <div
              className={cx(
                { "col-md-6 order-first": imageLeft },
                {
                  "col-md-5 col-lg-6 offset-md-1 order-first order-md-last":
                    !imageLeft,
                }
              )}
            >
              <img
                className="w-100"
                alt=""
                src={get(image, "[0].url", false)}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default OverviewItem
